import request from '@/utils/request'

//是否参与过活动
export const isAttendAct = (data) => {
  return request({
    url: '/busi/qryOrderByMarket',
    method: 'post',
    data,
    encrypt: true,
  })
}

//充值档位信息
export const rechargeStall = (data) => {
  return request({
    url: '/busi/qryRechargeList',
    method: 'post',
    data,
    encrypt: true,
  })
}

//短信验证码校验
export const checkSmsCode = (data) => {
  return request({
    url: '/login/checkSmsCode',
    method: 'post',
    data,
    encrypt: true,
  })
}

//短信验证码校验-H5
export const checkSmsCodeH5 = (data) => {
  return request({
    url: '/limit/czfs/checkCzfsSmsCode',
    method: 'post',
    data,
    encrypt: true,
  })
}

//订单提交
export const submitOrder = (data) => {
  return request({
    url: '/trade/submitOrder',
    method: 'post',
    data,
    encrypt: true,
  })
}

//订单提交
export const submitOrderH5 = (data) => {
  return request({
    url: '/limit/czfs/submitCzfsOrder',
    method: 'post',
    data,
    encrypt: true,
  })
}

//创建支付订单
export const createPaymentOrder = (data) => {
  return request({
    url: '/paycenter/createPaymentOrder',
    method: 'post',
    data,
    encrypt: true,
  })
}

//下单接口
export const paymentPayOrder = (data) => {
  return request({
    url: '/paycenter/paymentPayOrder',
    method: 'post',
    data,
    encrypt: true,
  })
}

//查询待支付订单
export const pendingPayOrder = (data) => {
  return request({
    url: '/trade/qryOrderList',
    method: 'post',
    data,
    encrypt: true,
  })
}

//插入数据
export const insert = (data) => {
  return request({
    url: '/dataStatis/insert',
    method: 'post',
    data,
  })
}
